// Wetter und Ortssuche (Kap. 15.3): Spiegel von apps/core/src/contracts/weather.ts. Daten kommen vom Server
// (Open-Meteo-Proxy), der Manager fragt nie direkt im Internet.
import type { WeatherData, WeatherProvider } from '@disploraq/layouts';
import { api } from './client';

export interface Place {
  id: number;
  name: string;
  region: string | null;
  country: string | null;
  countryCode: string | null;
  lat: number;
  lon: number;
  timezone: string | null;
}

/** Ortssuche (GET /api/v1/geocode). */
export async function searchPlaces(q: string, lang: string, signal?: AbortSignal): Promise<Place[]> {
  const qs = new URLSearchParams({ q, lang: ['de', 'en', 'fr', 'it'].includes(lang) ? lang : 'de' });
  return (await api.get<{ items: Place[] }>(`/geocode?${qs}`, signal ? { signal } : {})).items;
}

/** Zweite Zeile eines Vorschlags: „Zürich, Schweiz". */
export const placeDetail = (p: Place): string => [p.region && p.region !== p.name ? p.region : null, p.country].filter(Boolean).join(', ');

const TTL_MS = 10 * 60_000;
const memo = new Map<string, { at: number; value: Promise<WeatherData | null> }>();

/**
 * Wetter für die Vorschau im Manager (GET /api/v1/weather). Vorschaubilder derselben Folie teilen sich einen Abruf
 * (10 Min.); Fehler bzw. abgeschaltetes Wetter → null (Baustein zeigt „Wetter nicht verfügbar").
 */
export const managerWeather: WeatherProvider = ({ lat, lon }) => {
  const key = `${lat.toFixed(2)},${lon.toFixed(2)}`;
  const hit = memo.get(key);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.value;
  const value = api.get<WeatherData>(`/weather?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`).catch(() => {
    memo.delete(key);
    return null;
  });
  memo.set(key, { at: Date.now(), value });
  return value;
};
